/**
 * css unit 가공 리턴
 * @param unit
 */
export const getCssUnit = (unit: number | string): string => {
  if (typeof unit === 'string') {
    return unit
  }
  return `${unit}px`
}
